// extracted by mini-css-extract-plugin
export var mugShotFunctie = "mug-shot-module--mug-shot-functie--a1e24";
export var mugShotImage = "mug-shot-module--mug-shot-image--ada51";
export var mugShotItem = "mug-shot-module--mug-shot-item--e6919";
export var mugShots = "mug-shot-module--mug-shots--5715e";
export var teamSocialLinkLinkedin = "mug-shot-module--team-social-link-linkedin--7437e";
export var teamSocialLinkMail = "mug-shot-module--team-social-link-mail--14670";
export var teamSocials = "mug-shot-module--team-socials--0d219";